import React, { useState, useEffect } from 'react';
import { getOrCreateCustomer } from './dbOperations';
import ProductCustomizer from './components/ProductCustomizer';
import Cart from './components/Cart';




function App() {
  const [customerId, setCustomerId] = useState(null);

  useEffect(() => {
    const sessionId = localStorage.getItem('sessionId') || Date.now().toString();
    localStorage.setItem('sessionId', sessionId);
    getOrCreateCustomer(sessionId).then(customer => {
      console.log('Set customer ID:', customer.id);
      setCustomerId(customer.id);
    });
  }, []);

  return (
    <div className="App">
      <h1>Custom Product Store</h1>
      <ProductCustomizer />
      {customerId && <Cart customerId={customerId} />}
    </div>
  );
}

export default App;